import { IRoomWasDeleted } from '../../../actions/bookingCalendar/room/requestDeleteRoom'
import { IBookingCalendarStore } from '../index'

export default function(
  state: IBookingCalendarStore,
  action: IRoomWasDeleted,
): IBookingCalendarStore {
  return {
    ...state,
    rooms: state.rooms.filter(room => room.id !== action.roomId),
  }
}
